<template>
  <span class="data align-self-start" @click="stopInterval()">
    <slot name="button"></slot>
  </span>
</template>

<script>
/**
 * @description Composante générique qui indique quand le décompte est terminé
 * @author Benjamin Caron
 * @author Samuel Colassin
 * @author Alexandre Gallant
 * @vue-prop {Number} initialCountdownTime - La durée du décompte
 * @vue-prop {Boolean} shouldStartInterval - Si on doit débuter un nouveau décompte
 * @vue-data {Number} intervalId - L'id de l'intervalle en cours
 * @vue-data {Number} timeLeft - Le temps qu'il reste au décompte
 * @vue-event {void} onTimeoutCompleted - Émet que le décompte est terminé
 * @vue-event {Number} onCountdownChange - Émet le temps qu'il reste au décompte
 */
export default {
  name: "GenericRefresh",
  props: {
    initialCountdownTime: {
      required: true,
      type: Number
    },
    shouldStartInterval: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    /**
     * @description Démarre un intervalle si le prop change et qu'il est vrai
     * @param {Boolean} value Si on doit démarrer le timer
     */
    shouldStartInterval: function(value) {
      if (value) {
        this.$emit("onCountdownChange", this.timeLeft);
        this.intervalId = this.startInterval();
      }
    }
  },
  data() {
    return {
      intervalId: 0,
      timeLeft: this.initialCountdownTime
    };
  },
  methods: {
    /**
     * @description Démarre un intervalle qui vérifie s'il reste du temps au décompte
     */
    startInterval: function() {
      return setInterval(this.checkTimeLeft, 1000);
    },
    /**
     * @description Décrémente et vérifie qu'il reste du temps au décompte, arrête l'intervalle
     * s'il n'y en a plus
     */
    checkTimeLeft: function() {
      this.decrementCountdown();
      if (this.timeLeft <= 0) {
        this.stopInterval();
      }
    },
    /**
     * @description On arrête l'intervalle et on émet qu'il est terminé
     */
    stopInterval: function() {
      this.timeLeft = this.initialCountdownTime;
      clearInterval(this.intervalId);
      this.$emit("onTimeoutCompleted");
    },
    /**
     * @description Décrémente le temps restant du décompte
     */
    decrementCountdown: function() {
      this.timeLeft -= 1000;
      this.$emit("onCountdownChange", this.timeLeft);
    }
  },
  /**
   * @description Démarre le décompte (si celui-ci doit être démarré)
   */
  created() {
    if (this.shouldStartInterval) this.startInterval();
  }
};
</script>
